import { gql } from "@apollo/client"

export const getAllQuizMasterQuery = gql`
  query getKidProfiles(
    $parentId: Int
    $searchString: String
    $pageNumber: Float
    $pageLimit: Float
  ) {
    getAllKidProfiles(
      parentId: $parentId
      searchString: $searchString
      pageNumber: $pageNumber
      pageLimit: $pageLimit
    ) {
      items {
        id
        name
        dob
        gender
        isActive
        tagline
        parentId

        createdDate
        totalCoins
        totalPoints
        photoURL

        error {
          statusCode
          message
        }
      }
      pagination {
        pageNumber
        pageLimit
        totalCount
      }
    }
  }
`
export const deleteQuizMasterMutation = gql`
  mutation deleteQuizMaster($id: Int!) {
    deleteQuizMaster(id: $id) {
      id
      status
      error {
        message
      }
    }
  }
`
export const getOneQuizMasterQuery = gql`
  query getQuizMaster($id: Int!) {
    getOneQuizMaster(id: $id) {
      id
      name
      ageGroupId
      dateRangeMin
      dateRangeMax
      dateRange
    }
  }
`
export const createQuizMasterMutation = gql`
  mutation createQuizMaster($data: quizMasterInput) {
    createQuizMaster(data: $data) {
      id
      status
      error {
        message
      }
    }
  }
`
export const updateQuizMasterMutation = gql`
  mutation updateQuizMaster($id: Int!, $data: quizMasterInput) {
    updateQuizMaster(id: $id, data: $data) {
      id
      status
      error {
        message
      }
    }
  }
`
export const getAllAgeGroup = gql`
  query getAgeGroups(
    $searchString: String
    $pageNumber: Float
    $pageLimit: Float
  ) {
    getAllAgeGroupMasters(
      searchString: $searchString
      pageNumber: $pageNumber
      pageLimit: $pageLimit
    ) {
      items {
        id
        ageGroupTitle
      }
    }
  }
`
